module.exports = __webpack_public_path__ + "img/14.81549bce.webp";